import { render, staticRenderFns } from "./AdditionalRequirementForProject.vue?vue&type=template&id=16001379&scoped=true&"
import script from "./AdditionalRequirementForProject.vue?vue&type=script&lang=js&"
export * from "./AdditionalRequirementForProject.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalRequirementForProject.vue?vue&type=style&index=0&id=16001379&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16001379",
  null
  
)

export default component.exports